import { h } from 'preact';
import { I18nProvider, useTranslation } from '../utils/i18n';
import translations from '../lang/welcome.json';

function WelcomeContent({ onGetStarted }) {
  const { t } = useTranslation();

  return (
    <div class="screen">
      <h2>{t('overline')}</h2>
      <h1>{t('title')}</h1>
      <hr></hr>
      <div class="content">
        <div class="copy">
          <p dangerouslySetInnerHTML={{ __html: t('intro', { 0: '<a href="https://developer.chrome.com/docs/devtools/ai-assistance/?utm_source=google-hpp&utm_medium=embedded_marketing_link&utm_campaign=Q4-demo&utm_content=CTA">' }) }}></p>
          <ul class="instructions">
            <li>{t('step1')}</li>
            <li>{t('step2')}</li>
            <li>{t('step3')}</li>
          </ul>

          <p dangerouslySetInnerHTML={{ __html: t('docs', { 0: '<a href="https://developer.chrome.com/docs/devtools/ai-assistance/?utm_source=google-hpp&utm_medium=embedded_marketing_link&utm_campaign=Q4-demo&utm_content=CTA">' }) }}></p>
          <p><strong dangerouslySetInnerHTML={{ __html: t('cta', { 0: '<a href="https://developer.chrome.com/docs/devtools/ai-assistance/?utm_source=google-hpp&utm_medium=embedded_marketing_link&utm_campaign=Q4-demo&utm_content=CTA">' }) }}></strong></p>
        </div>

        <div class="visual">
          <video src="./welcome.mp4" poster="./welcome-poster.jpg" width="1920" height="1080" loop autoplay playsInline muted></video>
        </div>
      </div>
      
      <div class="controls">
        <div class="start">
          <button class="button" onClick={onGetStarted}>{t('button')}</button>
        </div>
      </div>
    </div>
  );
}

export function Welcome(props) {
  return (
    <I18nProvider translations={translations}>
      <WelcomeContent {...props} />
    </I18nProvider>
  );
}
